import { CNCMachineCommand } from '../implementations/CNCMachine/types';
import { CustomGripperCommand } from '../implementations/CustomGripper/types';
import { EwellixLiftTLTCommand } from '../implementations/EwellixLiftTLT/types';
import { FTPServerCommand } from '../implementations/FTPServer/types';
import { GPUTaskRunnerCommand } from '../implementations/GPUTaskRunner/types';
import { MiraiControllerCommand } from '../implementations/MiraiController/types';
import { ModbusTCPServerCommand } from '../implementations/ModbusTCPServer/command';
import { OnRobot2FG14Command } from '../implementations/onRobot/OnRobot2FG14/types';
import { OnRobot2FG7Command } from '../implementations/onRobot/OnRobot2FG7/types';
import { OnRobot3FG15Command } from '../implementations/onRobot/OnRobot3FG15/types';
import { OnRobotDualQuickChangerCommand } from '../implementations/onRobot/OnRobotDualQuickChanger/types';
import { OnRobotHexECommand } from '../implementations/onRobot/OnRobotHexE/types';
import { OnRobotScrewdriverCommand } from '../implementations/onRobot/OnRobotScrewdriver/types';
import { OnRobotVGP20Command } from '../implementations/onRobot/OnRobotVGP20/types';
import { Robotiq2FCommand } from '../implementations/robotiq/Robotiq2F/types';
import { RobotiqEPickCommand } from '../implementations/robotiq/RobotiqEPick/types';
import { S3BucketCommand } from '../implementations/S3Bucket/types';
import { SchunkEGxCommand } from '../implementations/schunk/SchunkEGx/types/SchunkEGxCommand';
import { StandardBotsRO1Command } from '../implementations/StandardBotsRO1/types/StandardBotsRO1Command';
import { MillerWeldMachineCommand } from '../implementations/WeldMachine/MillerWeldMachine/types/MillerWeldMachineCommands';
import { WeldMachineCommand } from '../implementations/WeldMachine/shared/types/WeldMachineCommand';

/**
 * Commands are send from either remote control or routine runner to the device
 * to perform some action.
 * Devices should check that supplied commands match their expected type
 * and ignore commands that they don't understand.
 * Commands must be JSON serializable and have a 'kind' attribute (string).
 */
export const DeviceCommandsRegistry = [
  OnRobot3FG15Command,
  OnRobot2FG7Command,
  OnRobot2FG14Command,
  OnRobotDualQuickChangerCommand,
  OnRobotScrewdriverCommand,
  OnRobotVGP20Command,
  Robotiq2FCommand,
  RobotiqEPickCommand,
  EwellixLiftTLTCommand,
  ModbusTCPServerCommand,
  FTPServerCommand,
  S3BucketCommand,
  SchunkEGxCommand,
  CNCMachineCommand,
  WeldMachineCommand,
  MillerWeldMachineCommand,
  CustomGripperCommand,
  StandardBotsRO1Command,
  OnRobotHexECommand,
  GPUTaskRunnerCommand,
  MiraiControllerCommand,
] as const;
